const getters = {
  // 用户信息
  token: state => state.user.token,
  // 搜索返回
  upStation: state => state.search.upStation,
  downStation: state => state.search.downStation
}
export default getters
